import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { Strong, SubsidizedIcon, Text } from 'main/ui'
import { AssetName } from 'main/util/asset'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-SUBSIDIZED`

interface IProps {
  subsidizedCareAccepted: boolean
}

export default function Subsidized(props: IProps) {
  const { subsidizedCareAccepted } = props
  const { t } = useTranslation(NAMESPACE)
  const whitelabel = useWhitelabel()
  const subsidyAltTextTitle = whitelabel.getAsset(
    AssetName.SUBSIDY_ALT_TEXT_INTERNALSCHOOL_BASICS_SUBSIDIZED_TITLE,
  )

  return (
    <Bullet icon={<SubsidizedIcon />}>
      <Strong>{t(subsidyAltTextTitle || 'INTERNALSCHOOL-BASICS-SUBSIDIZED-TITLE')}</Strong>
      <Text muted>{subsidizedCareAccepted ? t(`${PRE}-ACCEPTED`) : t(`${PRE}-NOT-ACCEPTED`)}</Text>
    </Bullet>
  )
}
